import React from 'react';
import PropTypes from 'prop-types';
import { IconPeopleDensity } from '@bvt-icons';
import './PeopleDensitySidebar.scss';

/**
 * People Density Sidebar
 * @param {object} props
 * @param {string} props.value
 */

function PeopleDensitySidebar(props) {
  const { value } = props;

  return (
    <div className='feature_peopleDensitySidebar'>
      <IconPeopleDensity value={value} />
    </div>
  );
}

export default PeopleDensitySidebar;

PeopleDensitySidebar.defaultProps = {
  value: '25.44722',
};

PeopleDensitySidebar.propTypes = {
  value: PropTypes.string,
};
